// prettier-ignore
import { mapAdditionalDetailsIntoLockObjects } from '@tv2-player/common-utils/mapAdditionalDetailsIntoLockObjects';
import { NormalizedError } from '../types';

export default {
  UNKNOWN: (error: NormalizedError) => ({
    header: 'Hov, noget gik galt.',
    message: 'Der skete desværre en fejl under afspilningen.',
    theme: 'dark',
  }),
  NOT_AVAILABLE: (error: NormalizedError) => ({
    header: 'Indhold ikke tilgængeligt.',
    message: 'Måske er indholdet fjernet, eller der kan være sket en anden fejl.',
    tip: 'Du kan også gå til vores kundecenter og få hjælp til mulige løsninger på problemet.',
    theme: 'dark',
  }),
  LOGIN: (error: NormalizedError) => ({
    header: 'Indholdet kræver abonnement.',
    message: 'Log ind på din enhed for at se videre.',
    theme: 'dark',
  }),
  SUBSCRIPTION: (error: NormalizedError) => ({
    header: 'Indholdet kræver et andet abonnement.',
    message: 'Du kan opgradere dit abonnement på mit.tv2.dk.',
    theme: 'dark',
  }),
  GEOBLOCKED: (error: NormalizedError) => ({
    header: 'Indhold ikke tilgængeligt.',
    message:
      'Af rettighedsmæssige årsager er denne udsendelse ikke tilgængelig i lande udenfor EU/EØS. Vi beklager.',
    tip: 'Vi har aftaler med mange forskellige indholdsudbydere og rettighederne varierer. På tv2play.dk kan du læse mere om adgangsbegrænsninger uden for Danmark.',
    theme: 'dark',
  }),
  CONCURRENCY: (error: NormalizedError) => ({
    header: 'Du forsøger at igangsætte for mange afspilninger på én gang.',
    message: 'Af rettighedsmæssige årsager kan du kun igangsætte 2 afspilninger ad gangen.',
    theme: 'dark',
  }),
  DUPLICATE_LIVE_STREAM_VIOLATION: (error: NormalizedError) => {
    const additionalDetails = error?.raw?.additionalDetails;
    const mappedLockObjects = mapAdditionalDetailsIntoLockObjects(additionalDetails);

    return {
      header: 'Denne livekanal streames på en anden enhed',
      message: `Du kan kun afspille den samme livekanal på én enhed ad gangen. 
                For at fortsætte skal du stoppe afspilningen på følgende:
                <div class='flex flex-col mt-[calc((20_/_1920)_*_100vw)] '>
                  ${(mappedLockObjects ?? [{}])
                    ?.map(
                      lockObject => `
                  <div class='flex mt-[calc((20_/_1920)_*_100vw)]'>
                    <div class='font-bold w-[calc((200_/_1920)_*_100vw)]'>Enhed</div>
                    <div class='value'>
                      <div>${lockObject.platform ? lockObject?.platform : 'Ukendt'}</div>
                      <div> ${lockObject.platformClass ? lockObject?.platformClass : ''} </div>
                     </div>
                  </div>`
                    )
                    ?.join('')}
                 </div>`,
      theme: 'light',
    };
  },
  DEVICE_NOT_GRANTED: (error: NormalizedError) => ({
    header: 'Du har anvendt alle dine enheder',
    message:
      'Der kan logges ind fra 5 enheder i samme husstand.<br/>Du kan fjerne en enhed på Mit TV 2.',
    theme: 'dark',
  }),
  SUBTITLE_ERROR: (error: NormalizedError) => ({
    header: 'Hov, noget gik galt.',
    message:
      'Der skete desværre en fejl under afspilningen. Prøv at slå undertekster fra og prøv igen.',
    theme: 'dark',
  }),
} as const;
